import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { BranchMasterService } from '../../_services/_masters/branch-master.service';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Http, Response } from '@angular/http';
import { environment } from '../../../environments/environment';

import swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
// import * as $ from 'jquery';
declare var $ : any;
class BranchMasterForm {
	branch_name:string;
	address : string;
	branch: string;
	contact_no: string;
}
@Component({
  selector: 'app-branch-master',
  templateUrl: './branch-master.component.html',
  styleUrls: ['./branch-master.component.css']
})
export class BranchMasterComponent implements OnInit {
 	branchMasterForm : FormGroup;
	modalBranchMasterForm : FormGroup;
	modalData : any;

	// Data Table Configurations
	dtOptions: any = {};
	dataTable: any;
	dtTrigger: Subject<any> = new Subject();
	branch_form: BranchMasterForm[] = [];

	stations : string[] = [];
	currentUser  : any ;
	token : any ;
	user_role : string = null ;
	user_branch : string = null ;
	url = environment.url;
	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;

	query : any = null;
	response : any = null;
	
	constructor( private branchMasterService : BranchMasterService, private http: Http) { }

	ngOnInit() {

		this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
		this.token = this.currentUser.token;
		this.user_role = this.currentUser.role;
		this.user_branch = this.currentUser.branch;
		console.log(this.user_role);
		console.log(this.user_branch);

		this.branchMasterForm = new FormGroup({
			'branch_name': new FormControl(null , Validators.required),
			'branch_prefix': new FormControl(null , Validators.required),
			'address': new FormControl(null , Validators.required),
			'phone_no': new FormControl(null , Validators.required)
		});
		
		this.modalBranchMasterForm = new FormGroup({
			'branch_name': new FormControl(null , Validators.required),
			'branch_prefix': new FormControl(null , Validators.required),
			'address': new FormControl(null , Validators.required),
			'phone_no': new FormControl(null , Validators.required)
		});


		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 5,
			responsive: true,
			// select:true,
			rowCallback: (row: Node, data: any[] | Object, index: number) => {
				const self = this;
				// Unbind first in order to avoid any duplicate handler
				// (see https://github.com/l-lin/angular-datatables/issues/87)
				$('td', row).unbind('click');
				$('td', row).bind('click', () => {
					self.someClickHandler(data);
				});
				return row;
			},
			dom: 'Bfrtip',
			// Configure the buttons
			buttons: [
				// 'columnsToggle',
				'colvis',
				'copy',
				'print',
				'excel'
			]
		};

	this.http.get(this.url + '/branch/all')
	// this.http.get('http://backendtransport.iogreen.in/masters/branchMaster/all')
		.map(this.extractData)
		.subscribe(forms => {
			this.branch_form = forms;
			console.log(this.branch_form);
			// Calling the DT trigger to manually render the table
			this.dtTrigger.next();
		});
	}
	
	private extractData(res: Response) {
		const body = res.json();
		console.log(body.data || {});
		return body;

	};

	someClickHandler(info: any): void {
		this.branchMasterService.getBranchMasterFormWith(info[0])
		.subscribe(response => {
			console.log('aaaaa'+JSON.stringify(response))
			this.modalData = JSON.stringify(response)
			this.modalData =JSON.parse(this.modalData)

			this.modalBranchMasterForm.patchValue({
				"branch_name": this.modalData[0].branch_name,
				"branch_prefix": this.modalData[0].branch_prefix,
				"address": this.modalData[0].address,
				"phone_no": this.modalData[0].phone_no
			});
		});	
		$("#default-modal").modal('show');
	};

	submit(){

		console.log(this.branchMasterForm.value);
		this.branchMasterService.addNewBranch(this.branchMasterForm.value)
		.subscribe(response => 
		{			
			if(response['status'])
			{
				swal('Save', 'Record save successfully', 'success');
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
				{
					dtInstance.destroy();
					this.http.get(this.url + '/branch/all')
						.map(this.extractData)
						.subscribe(forms => 
						{
							this.branch_form = forms;
							console.log(this.branch_form);
							// Calling the DT trigger to manually render the table
							this.dtTrigger.next();
						});
				});
				
			}
			else
			{
				swal('Oops!', 'Something went wrong on the page! <br />'+ response['message'], 'error');
			}
		});
	};

	updateBranch(){
		console.log(this.modalBranchMasterForm.value);
		console.log(this.modalData);

		this.query={
			"branch_oid" : this.modalData[0]._id,
			"branch_data" : this.modalBranchMasterForm.value
		}

		console.log(this.query);

		this.http.post( this.url + "/branch/update", this.query)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			console.log(this.response.status);
			if (this.response.status){

				if (this.response.message === 'Branch Updated Successfully'){
					swal(
						'Success',
						'Branch Form Updated Successfully',
						'success'
					);
					this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
					{
						dtInstance.destroy();
						this.http.get(this.url + '/branch/all')
							.map(this.extractData)
							.subscribe(forms => 
							{
								this.branch_form = forms;
								console.log(this.branch_form);
								// Calling the DT trigger to manually render the table
								this.dtTrigger.next();
							});
					});
				}

				if (this.response.message === 'Branch Information not Changed'){
					swal(
						'Info',
						'Branch information not changed',
						'info'
					);
				}
			}
			else{
				swal(
					'Unknown Error',
					'Please Refresh your page',
					'error'
				);
			}
			
		});
	};


	// DELETE CONSIGNOR
	deleteBranch(){
		console.log("Hello");

		this.query={
			"branch_id" : this.modalData[0]._id.$oid
		}

		console.log(this.query);

		swal({
			title: 'Are you sure?',
			text: 'You want to delete Branch',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'No, keep it'
		}).then((result) => {
			if (result.value) {
				this.http.post(this.url + '/masters/branch/delete', this.query)
				.map(response => response.json())
				.subscribe(
					(response)=>{
						console.log(response);
						if (response["status"]){
							console.log(response);
							console.log("success");
							swal('Deleted!','Your Branch has been deleted.','success');
							this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => 
							{
								dtInstance.destroy();
								this.http.get(this.url + '/branch/all')
								.map(this.extractData)
								.subscribe(forms => 
								{
									this.branch_form = forms;
									console.log(this.branch_form);
									// Calling the DT trigger to manually render the table
									this.dtTrigger.next();
								});
							});

							$("#default-modal").modal("hide");
							
						}else{
							swal("error","Oops , Somthing went wrong, Branch is not deleted","error");
						}
					},
					(error)=>console.log(error.json())
					);
			} 
			
		})
	}

	// END

}



// WEBPACK FOOTER //
// /Users/meghneel/work/baba_frontend/src/app/masters/branch-master/branch-master.component.ts